import React from 'react';
import {Avatar, Space} from 'antd';
import PropTypes from 'prop-types';
import {
  StyledUserDetailsEmail,
  StyledUserDetailsName
} from './StyledUserDetails';
import {textHelpers} from '../../utils/helpers';

const UserDetails = ({
  avatarProps,
  email = true,
  user,
  ...rest
}) => {

  const userEmail = user?.email || '';
  const name = user?.full_name || '';
  const src = user?.logo || undefined;
  const initials = textHelpers.getInitials(name || userEmail);

  return (
    <Space
      size='small'
      {...rest}
    >
      <Avatar {...avatarProps} src={src}>
        {initials}
      </Avatar>
      <Space
        size={0}
        direction='vertical'
      >
        {name && <StyledUserDetailsName>{name}</StyledUserDetailsName>}
        {email && <StyledUserDetailsEmail>{userEmail}</StyledUserDetailsEmail>}
      </Space>
    </Space>
  );
}

UserDetails.propTypes = {
  email: PropTypes.bool,
  user: PropTypes.shape({
    email: PropTypes.string,
    full_name: PropTypes.string,
    logo: PropTypes.string,
  })
}

export default UserDetails;
